/**
 * Recall Management Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const recallRoutes: RouteRecordRaw[] = [
  {
    path: '/recall',
    name: 'recall',
    component: () => import('./views/RecallListView.vue'),
    meta: {
      title: () => i18next.t('recall.pageTitle'),
      requiredEntitlement: 'RECALL',
      breadcrumbs: [{ label: () => i18next.t('recall.pageTitle') }],
    },
  },
  {
    path: '/recall/:id/impact',
    name: 'recall-impact',
    component: () => import('./views/RecallImpactSummaryView.vue'),
    meta: {
      title: () => i18next.t('recall.impact.pageTitle'),
      requiredEntitlement: 'RECALL',
      breadcrumbs: [
        { label: () => i18next.t('recall.pageTitle'), to: '/recall' },
        { label: () => i18next.t('recall.impact.pageTitle') },
      ],
    },
  },
];
